const firebaseConfig = {
  apiKey: "AIzaSyCvGXItoaf3-TI2ryBtIBuYcJ_deOMQgqA",
  authDomain: "crypto-hunter-6467c.firebaseapp.com",
  projectId: "crypto-hunter-6467c",
  storageBucket: "crypto-hunter-6467c.appspot.com",
  messagingSenderId: "936011863307",
  appId: "1:936011863307:web:fcb0907ba1fb61eafe3e0e"
};

export default firebaseConfig;
